import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Phone } from 'lucide-react';
import { companyInfo, services } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms & Conditions', path: '/terms-conditions' }
  ];

  // Get main services
  const mainServices = services.filter(s => s.slug !== 'other-services');
  const otherServicesData = services.find(s => s.slug === 'other-services');

  return (
    <footer className="bg-[#000000] border-t border-[#3f4816] pt-16 sm:pt-20 md:pt-24">
      <div className="container mx-auto px-4 sm:px-6 pb-12 sm:pb-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12">
          {/* Company Info - Updated to new logo-02.png */}
          <div>
            <div className="mb-4 sm:mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_publishhub/artifacts/bqttbt7x_logo-02.png"
                alt="White House Publishers"
                className="h-10 sm:h-12 w-auto"
              />
            </div>
            <p className="text-[#888680] mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
              Transforming stories into masterpieces. Your trusted partner in book publishing.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3 mb-4 sm:mb-6">
              {/* Phone Number */}
              <div className="flex items-center gap-3 text-[#888680]">
                <Phone size={18} className="text-[#F4D03F] flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-[#F4D03F] transition-colors text-sm sm:text-base">
                  {companyInfo.phone}
                </a>
              </div>
              
              {/* Email */}
              <div className="flex items-center gap-3 text-[#888680]">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#F4D03F] flex-shrink-0">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <a href="mailto:info@whitehousepublishers.com" className="hover:text-[#F4D03F] transition-colors text-sm sm:text-base">
                  info@whitehousepublishers.com
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex gap-3 sm:gap-4">
              <a href="#" className="text-[#F4D03F] hover:text-[#f8d47a] transition-colors">
                <Facebook size={18} />
              </a>
              <a href="#" className="text-[#F4D03F] hover:text-[#f8d47a] transition-colors">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="#" className="text-[#F4D03F] hover:text-[#f8d47a] transition-colors">
                <Instagram size={18} />
              </a>
              <a href="#" className="text-[#F4D03F] hover:text-[#f8d47a] transition-colors">
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Main Services */}
          <div>
            <h4 className="text-[#F4D03F] font-bold text-base sm:text-lg uppercase mb-4 sm:mb-6">Our Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              {mainServices.map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Other Services */}
          <div>
            <h4 className="text-[#F4D03F] font-bold text-base sm:text-lg uppercase mb-4 sm:mb-6">Other Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/services/book-video-trailer"
                  className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Book Video Trailer
                </Link>
              </li>
              <li>
                <Link
                  to="/services/web-design-seo"
                  className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Web Design & SEO
                </Link>
              </li>
              <li>
                <Link
                  to="/services/illustration-services"
                  className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Illustration Services
                </Link>
              </li>
              <li>
                <Link
                  to="/services/articles-services"
                  className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Articles Services
                </Link>
              </li>
              <li>
                <Link
                  to="/services/book-design-services"
                  className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Book Design Services
                </Link>
              </li>
              <li>
                <Link
                  to="/services/blog-writing-services"
                  className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Blog Writing Services
                </Link>
              </li>
              <li>
                <Link
                  to="/services/web-content-writing"
                  className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Web Content Writing
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#F4D03F] font-bold text-base sm:text-lg uppercase mb-4 sm:mb-6">Quick Links</h4>
            <ul className="space-y-2 sm:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-[#888680] hover:text-[#F4D03F] transition-colors text-sm sm:text-base"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#3f4816] mt-8 sm:mt-12 pt-6 sm:pt-8 text-center">
          <p className="text-[#888680] text-xs sm:text-sm">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;